import React from "react";
import type { ViewComponent } from "@frui.ts/views/dist";
import { registerView, View } from "@frui.ts/views/dist";
import { observer } from "mobx-react-lite";
import { Modal } from "react-bootstrap";
import BankAccountBlacklistDetailViewModel from "viewModels/finance/bankAccountBlacklists/bankAccountBlacklistDetailViewModel";
import EditableDetailView from "../../common/editableDetailView";
import BankAccountBlacklistForm from "./bankAccountBlacklistForm";

const BankAccountBlackListDetailView: ViewComponent<BankAccountBlacklistDetailViewModel> = observer(({ vm }) => {
  return (
    <Modal scrollable show={true} onHide={vm.onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>{vm.translate(vm.isEditable ? "edit" : "detail")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <View vm={vm.alertsViewModel} useLifecycle={true} />
        <EditableDetailView vm={vm} form={<BankAccountBlacklistForm vm={vm} />} hideTitle={true} />
      </Modal.Body>
    </Modal>
  );
});

registerView(BankAccountBlackListDetailView, BankAccountBlacklistDetailViewModel);
